import { render, staticRenderFns } from "./UnpaidBillList.vue?vue&type=template&id=22b18066&scoped=true"
import script from "./UnpaidBillList.vue?vue&type=script&lang=js"
export * from "./UnpaidBillList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b18066",
  null
  
)

export default component.exports